module.exports = __webpack_public_path__ + "img/icon-24-ic-pencil.9bc95bc9.svg";